import { Link } from "react-router";
import { Trainer } from "../components/Trainer";
import { useT } from "../i18n";

/** §14.4 Landing: one live exercise you can solve right there. */
export function Landing() {
  const t = useT();
  return (
    <main className="page">
      <section className="hero">
        <div>
          <h1>{t("landing.title")}</h1>
          <p>{t("landing.lead")}</p>
          <div className="row" style={{ marginTop: 20 }}>
            <Link className="btn primary big" to="/register">{t("landing.start")}</Link>
            <Link className="btn big" to="/login">{t("nav.login")}</Link>
          </div>
          <p className="small muted" style={{ marginTop: 24 }}>
            <Link to="/train/daily">{t("train.daily")} →</Link>
          </p>
        </div>
        <div className="stack">
          <span className="muted small">{t("landing.try")}</span>
          <Trainer mode="taster" compact />
        </div>
      </section>
    </main>
  );
}
